import React from 'react'
import { IconArrowOutlineLeft } from 'components/Zui/Icon'
import { InteractiveIcon } from 'components/Zui'
import { icons } from 'app/constants'
import SelectedFileActions from 'components/SelectedFileActions'
import TagPills from 'components/TagPills'
import './index.css'

const FileViewHeader = ({
    isFullscreen,
    isShared,
    isDownloadable,
    onClose,
    tags,
    fileType,
    title,
    handleDownloadFiles,
    handleTagFiles,
    handleAddFiles,
    handleShareFiles,
    isFavorite,
    handleFavorite,
    handleDeleteFiles,
    upadatedDate,
    upadatedTime,
}) => {
    const ICON = fileType === 'video' ? icons['videoCam'] : icons['image']

    return (
        <div className={`player-top-panel ${isFullscreen ? 'transparent-bg' : ''}`}>
            <div className="detail-view-top-pannel-wrapper">
                <div className="detail-view-top-pannel-left">
                    <div className="title-close-wrapper">
                        <div className="detail-view-close-icon-wrapper" onClick={onClose}>
                            <InteractiveIcon theme="zbds-dark">
                                <IconArrowOutlineLeft />
                            </InteractiveIcon>
                        </div>
                        <div className="detail-view-file-title">
                            <span>{title}</span>
                        </div>
                        <div className="custom-divider" style={{ marginLeft: '12px' }}></div>
                    </div>
                    <div className="file-detail-wrapper">
                        <div className="detail-view-close-icon-wrapper">{ICON && <ICON />}</div>
                        <div className="custom-divider-sm"></div>
                        <div className="detail-view-file-title">
                            <span>{upadatedDate} </span>
                        </div>
                        <div className="custom-divider-sm"></div>
                        <div className="detail-view-file-title">
                            <span>{upadatedTime}</span>
                        </div>
                        <div
                            className="custom-divider"
                            style={{ marginLeft: '12px', marginRight: '12px' }}
                        ></div>
                        {tags?.length > 0 && <TagPills data={tags} sliceBy="3" />}
                    </div>
                </div>
                <div className="detail-view-top-pannel-right">
                    <SelectedFileActions
                        actions={[
                            {
                                icon: 'share',
                                onClick: handleShareFiles,
                                isDisabled: isShared,
                            },
                            {
                                icon: isFavorite ? 'favoriteFilled' : 'favorite',
                                onClick: handleFavorite,
                                isDisabled: isShared,
                            },
                            {
                                icon: 'moveFolder',
                                onClick: handleAddFiles,
                                isDisabled: isShared,
                            },
                            {
                                icon: 'tag',
                                onClick: handleTagFiles,
                                isDisabled: isShared,
                            },
                            {
                                icon: 'download',
                                onClick: handleDownloadFiles,
                                isDisabled: !isDownloadable || (isShared && fileType !== 'image'),
                            },
                            {
                                icon: 'delete',
                                onClick: handleDeleteFiles,
                                isDisabled: isShared,
                            },
                        ]}
                    />
                </div>
            </div>
        </div>
    )
}

export default FileViewHeader
